import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-index",
  "use": "icon-index-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-index\"><defs><style type=\"text/css\"></style></defs><path d=\"M189.12 402.624v437.952h145.472V597.184h353.92v243.392h146.368V402.624L512 202.56 189.12 402.56zM512 96l416 260.992V928H595.392v-243.392h-167.68V928H96V356.992L512 96z\" p-id=\"1716\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol